import { ApiService } from '@/api';
import { PendingUser } from '@/models';

export class AccessRequestApi {
  private readonly baseUrl = '/api/provision-user-requests';

  public async fetchAccessRequests(): Promise<PendingUser[]> {
    const response = await ApiService.get(this.baseUrl);

    return response.json();
  }

  public async approveAccessRequest(userId: string): Promise<void> {
    await ApiService.put(`${this.baseUrl}/${userId}/approved`);
  }

  public async declineAccessRequest(userId: string): Promise<void> {
    await ApiService.put(`${this.baseUrl}/${userId}/declined`);
  }
}
